import { AbstractData } from '@/modules/backend/Dto/AbstractData';

export type SearchEntityType = 'companies' | 'buildings' | 'locations' | 'accounts' | 'counters';

export interface SearchRequestDataInterface {
  entities: SearchEntityType[];
  query: string;
}

export class SearchRequestData extends AbstractData implements SearchRequestDataInterface {
  public entities!: SearchEntityType[];
  public query!: string;
}
